import React from "react";
import Skeleton from "react-loading-skeleton";

function SliderSkeleton() {
  return (
    <div className="flex flex-col gap-4 mb-14 w-full">
      <Skeleton
        containerClassName="px-6 lg:px-16 mt-10"
        height={360}
        className="normal-radius mx-auto"
      />
    </div>
  );
}

export default SliderSkeleton;
